import { ContactType } from '../enums/contactType'

export const headerNavigationTypes: ContactType[] = [ContactType.Company, ContactType.Person]
